import Typography from '@material-ui/core/Typography';
import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';

import useAllocationChangeTracking from '../../../shared/hooks/useAllocationChangeTracking';
import useAllocationConflictMessage from '../../../shared/hooks/useAllocationConflictMessage';
import { IEditAllocationFormValues } from '../../../shared/model/types';
import useClientAllocationsUpdate from '../../hooks/updateAllocations/useClientAllocationsUpdate';
import AllocationClientRowItem from '../ClientsRowItem/AllocationClientRowItem';
import AllocationClientsSelect from '../SelectFields/AllocationClientsSelect';

import layoutStyles from '../../../shared/components/EditAllocationFormLayout/EditAllocationFormLayout.module.scss';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AllocationClientsList: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const { markChanged, markDeleted } = useAllocationChangeTracking<IEditAllocationFormValues>({
    changedField: 'changedAllocationsIds',
    deletedField: 'deletedAllocationsIds',
  });
  const {
    fields: clientsAllocationsFields,
    updateAllocations,
    removeClientAt,
  } = useClientAllocationsUpdate(teamMemberIdx);
  const { clientListConflict: conflictMessage } = useAllocationConflictMessage({ teamMemberIdx });

  return (
    <>
      {conflictMessage && (
        <Typography variant="body2" className={layoutStyles.conflictAlert}>
          {conflictMessage}
        </Typography>
      )}
      <Typography variant="subtitle1" className={layoutStyles.assignedClientsSectionTitle}>
        Client Allocations
      </Typography>

      <AllocationClientsSelect
        teamMemberIdx={teamMemberIdx}
        teamMember={teamMember}
        updateAllocations={updateAllocations}
      />

      {clientsAllocationsFields.map((field, clientIdx) => (
        <AllocationClientRowItem
          key={field.id}
          field={field}
          clientIdx={clientIdx}
          teamMemberIdx={teamMemberIdx}
          memberId={teamMember.id}
          fieldsCount={clientsAllocationsFields.length}
          onMarkChanged={markChanged}
          onMarkDeleted={markDeleted}
          onRemove={removeClientAt}
        />
      ))}
    </>
  );
};

export default AllocationClientsList;
